module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_1.471fe0c.jpg";